import MedicalTestResults from "../../Components/MedicalTestResults";
import TalktodoctorIcon from "../../assets/talktodoctor.png";
import video_consult from "../../assets/video_consult.png";
import { useSignalR } from "../../Contexts/SignalRContext";
import Appointments from "../../Components/Appointments";
import { baseUrl } from "../../utilities/configurations";
import { Grid, CircularProgress } from "@mui/material";
import { useAuth } from "../../Contexts/AuthContext";
import LinkButton from "../../Components/LinkButton";
import ConsultIcon from "../../assets/consult.png";
import apiRequest from "../../utilities/request";
import { useNavigate } from "react-router-dom";
import BellIcon from "../../assets/bell.png";
import TestIcon from "../../assets/test.png";
import { useEffect, useState } from "react";

const drawerWidth = 240;

function WaveIcon() {
  return <span>👋</span>;
}

function Dashboard() {
  const [appointmentLoadState, setAppointmentLoadState] = useState("");
  const [upcomingAppointments, setUpcomingAppointments] = useState([]);
  const [medicalTestLoadState, setMedicalTestLoadState] = useState("");
  const [medicalTests, setMedicalTests] = useState([]);

  const { user, memberStatus, getMemberStatus, memberStatusLoadState } = useAuth();

  const { hasNewNotif, setHasNewNotif } = useSignalR();

  useEffect(() => {
    getUpcomingAppointments();
    getMedicalTests();
    //wont fetch again if already got the member status response
    if(memberStatus.status !== "success" && memberStatusLoadState !== "load"){
      getMemberStatus();
    }
  }, []);

  const getUpcomingAppointments = async (state) => {
    try {
      setAppointmentLoadState(state || "load");
      const res = await apiRequest(
        baseUrl + `/transaction/upcoming-appointments?max=${4}`,
        "GET"
      );
      if (!res.error) {
        setUpcomingAppointments(res.data || []);
        setAppointmentLoadState("load success");
      } else if (res.status >= 500) {
        setAppointmentLoadState("ISE");
      } else {
        setAppointmentLoadState("load failed");
      }
    } catch (error) {
      setAppointmentLoadState("timeout");
    }
  };

  const getMedicalTests = async (state) => {
    try {
      setMedicalTestLoadState(state || "load");
      const res = await apiRequest(
        baseUrl + `/transaction/medical-tests?max=${4}`,
        "GET"
      );
      if (!res.error) {
        setMedicalTests(res.data || []);
        setMedicalTestLoadState("load success");
      } else if (res.status >= 500) {
        setMedicalTestLoadState("ISE");
      } else {
        setMedicalTestLoadState("load failed");
      }
    } catch (error) {
      setMedicalTestLoadState("timeout");
    }
  };

  const renderIndicator = () => {
    let indicator = null;
    if (hasNewNotif) {
      indicator = (
        <span className="absolute bottom-0 right-0 w-[8px] h-[8px] rounded bg-[#db5454] mr-1" />
      );
    }
    return indicator;
  };

  const handleOpenNotifs=()=>{
    navigate("/notification");
    setHasNewNotif(false);
  }

  const handleGotoVideoConsult=()=>{
    window.open("https://teleconsult.maxicare.com.ph/member-validation","_blank","noopener");
  }

  const navigate = useNavigate();

  let appointmentsContent = null;
  if (appointmentLoadState === "load") {
    appointmentsContent = (
      <div className="w-full flex justify-center items-center p-3">
        <CircularProgress />
      </div>
    );
  } else {
    appointmentsContent = (
      <Appointments
        getUpcomingAppointments={getUpcomingAppointments}
        appointmentLoadState={appointmentLoadState}
        appointmentList={upcomingAppointments.slice(0, 3)}
      />
    );
  }

  let medTestContent = null;
  if (medicalTestLoadState === "load") {
    medTestContent = (
      <div className="w-full flex justify-center items-center p-3">
        <CircularProgress />
      </div>
    );
  } else {
    medTestContent = (
      <MedicalTestResults
        getMedicalTests={getMedicalTests}
        medicalTestLoadState={medicalTestLoadState}
        medicalTestsList={medicalTests.slice(0, 3)}
      />
    );
  }

  return (
    <div
      className=" sm:w-148 flex-grow cursor-default"
      style={{ width: `calc(100% - ${drawerWidth})` }}
    >
      <div className="sm:w-full bg-white rounded-xl sm:mt-12 sm:mb-4">
        <div className="p-4">
          <div className="flex justify-between items-center">
            <div className="flex-row items-center">
              <p className="text-lg sm:text-2xl font-bold">
                <WaveIcon /> Welcome back, {user?.first_name}!
              </p>
              <p className="text-[#60656D]">How can we help you today?</p>
            </div>
            <button
              className="relative"
              onClick={handleOpenNotifs}
            >
              {renderIndicator()}
              <img src={BellIcon} alt="Bell" className="w-10 h-10" />
            </button>
          </div>

          <Grid container spacing={2} style={{ marginTop: "4px" }}>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <button
                disabled={!memberStatus.isMember}
                className={`w-full h-full border text-center rounded-lg p-3 transition ease-in-out delay-75 flex justify-center ${
                  !memberStatus.isMember ? "opacity-50" : "hover:scale-105"
                }`}
                onClick={() => navigate("/consult-doctor/choose-policy")}
              >
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 flex items-center">
                    <img src={ConsultIcon} alt="Consult" className="w-full" />
                  </div>
                  <p className="text-lg font-semibold">Consult a doctor</p>
                  <p className="text-md text-gray-400">
                    via Primary Care Clinic
                  </p>
                </div>
              </button>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6}>
              <button
                disabled={!memberStatus.isMember}
                className={`w-full h-full border text-center rounded-lg p-3 transition ease-in-out delay-75 flex justify-center ${
                  !memberStatus.isMember ? "opacity-50" : "hover:scale-105"
                }`}
                onClick={() => navigate("/request-medical-test/policy")}
              >
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 flex items-center">
                    <img src={TestIcon} alt="Test" className="w-full" />
                  </div>
                  <p className="text-lg font-semibold">Request medical tests</p>
                  <p className="text-md text-gray-400">
                    via Primary Care Clinic
                  </p>
                </div>
              </button>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6}>
              <button
                disabled={!memberStatus.isMember}
                className={`w-full h-full border text-center rounded-lg p-3 transition ease-in-out delay-75 flex justify-center ${
                  !memberStatus.isMember ? "opacity-50" : "hover:scale-105"
                }`}
                onClick={() => navigate("/teleconsult-voice/instructions")}
              >
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 flex items-center">
                    <img
                      src={TalktodoctorIcon}
                      alt="Doctor"
                      className="w-full"
                    />
                  </div>
                  <p className="text-lg font-semibold">Talk to a doctor</p>
                  <p className="text-md text-gray-400">
                    via 24/7 Teleconsultation
                  </p>
                </div>
              </button>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <button
                onClick={handleGotoVideoConsult}
                disabled={!memberStatus.isMember}
                className={`w-full h-full border text-center rounded-lg p-3 transition ease-in-out delay-75 flex justify-center ${!memberStatus.isMember ? "opacity-50" : "hover:scale-105"}`}
              >
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 flex items-center">
                    <img
                      src={video_consult}
                      alt="video consult icon"
                      className="w-full"
                    />
                  </div>
                  <p className="text-lg font-semibold">Video Consult</p>
                  <p className="text-md text-gray-400">
                    via 24/7 Teleconsultation
                  </p>
                </div>
              </button>
            </Grid>
          </Grid>

          <div className="relative">
            <div className="px-4 py-3 mt-4 border rounded-lg">
              <p className="text-sm font-bold ml-2">
                For other hospitals and providers
              </p>
              <LinkButton
                disabled={memberStatus.isDependent}
                className={`text-sm text-blue-600 mt-1 ml-2 ${!memberStatus.isDependent && "hover:underline"}`}
                onClick={() => navigate("/loa-reimbursement-services")}
              >
                Tap here for LOA and Reimbursements
              </LinkButton>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg p-3 sm:mb-4">
        <div className="flex items-center p-2">
          <p className="text-lg font-semibold">Upcoming appointments</p>
          <LinkButton
            className={`text-md text-gray-500 ml-auto hover:underline
              ${upcomingAppointments.length >= 4 ? "" : "hidden"}`}
            onClick={() => navigate("/tracker/appointments")}
            disabled={["ISE", "retry"].includes(appointmentLoadState)}
          >
            View all
          </LinkButton>
        </div>

        <div className="relative">{appointmentsContent}</div>
      </div>

      <div className="bg-white rounded-lg p-3 mb-[56px] sm:mb-24 lg:mb-12">
        <div className="flex items-center p-2">
          <p className="text-lg font-semibold">Your medical tests</p>
          <LinkButton
            className={`text-md text-gray-500 ml-auto hover:underline
              ${medicalTests.length >= 4 ? "" : "hidden"}`}
            onClick={() => navigate("/tracker/medical-tests")}
            disabled={["ISE", "retry"].includes(medicalTestLoadState)}
          >
            View all
          </LinkButton>
        </div>

        <div className="relative">{medTestContent}</div>
      </div>
    </div>
  );
}

export default Dashboard;
